import { Component, Prop } from 'vue-property-decorator';
import BaseBlock from '@/blocks/base-block';
import { LocationDTO } from '../../../model/LocationDTO';
import { LocationStatsDTO } from '../../../model/LocationStatsDTO';
import SearchPanel from "@/components/search-panel/search-panel";
import { Block } from '../../../helpers/components';
import { apartmentsLocationsSearchData } from './apartments-locations-search.data';

@Block(apartmentsLocationsSearchData)
@Component({
	components: {
		SearchPanel
	}
})
export class ApartmentsLocationsSearchBlock extends BaseBlock {
	@Prop() locations: LocationDTO[];
	@Prop() locationStats: LocationStatsDTO[];
}

export default ApartmentsLocationsSearchBlock;
